var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinnerGap = function SvgSpinnerGap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 4v4a1 1 0 0 1-2 0V4a1 1 0 0 1 2 0m11 11h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-5.637 5.95a1 1 0 0 0-1.413 1.413l2.825 2.825a1 1 0 0 0 .713.3.96.96 0 0 0 .7-.3.987.987 0 0 0 0-1.413zM16 23a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m-6.363-2.05-2.825 2.825a.99.99 0 0 0 0 1.413.96.96 0 0 0 .7.3 1 1 0 0 0 .713-.3l2.825-2.825a1 1 0 0 0-1.413-1.413M9 16a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1m-.775-9.187a1 1 0 0 0-1.412 1.412l2.824 2.825a1.013 1.013 0 0 0 1.413 0 1 1 0 0 0 0-1.413z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    begin: "0s",
    dur: "1s",
    from: "0 16 16",
    repeatCount: "indefinite",
    to: "360 16 16",
    type: "rotate"
  }))));
};
export default SvgSpinnerGap;